export default __webpack_public_path__ + "static/media/onboarding_onemillionapps.36b18682.png";